import { Entity, IEntity } from "./Entity";

export interface IApp03TaskUserGroupsTemp extends IEntity {
    ZCoreUserGroupID?: number;
    TaskID?: number;
}

export class App03TaskUserGroupsTemp extends Entity implements IApp03TaskUserGroupsTemp {
    public ZCoreUserGroupID = null;
    public TaskID = null;
}